import { useTranslation } from "react-i18next";

import { HomeBack, HomeLogo } from "@/components/entry/HomeLinks";
import { CharacterEditor } from "./CharacterEditor";

/**
 * The profile as a page of its own: a brandbook animal, a brandbook colour and
 * a name, stored by the same hooks the room reads, so a change here is what
 * everybody at the fire sees. Theme and language are not the character's, so
 * they are not drawn here.
 */
export function ProfilePage() {
  const { t } = useTranslation();

  return (
    <main
      data-testid="profile-page"
      className="min-h-dvh bg-background text-foreground"
    >
      <header className="sticky top-0 z-20 border-b border-border bg-background/88 backdrop-blur-xl">
        <div className="mx-auto flex min-h-16 w-full max-w-5xl items-center gap-3 px-4 py-3">
          <HomeLogo />
          <HomeBack />
        </div>
      </header>

      <div className="mx-auto w-full max-w-5xl space-y-6 px-4 py-8">
        <h1 className="text-xl font-semibold tracking-tight">
          {t("profile.title")}
        </h1>
        <CharacterEditor />
      </div>
    </main>
  );
}
